import type {PageRouteConfig} from '@router';

import PinList from 'modules/Services/PromotionCenter/Pin/List/PinList';

export function createPromotionCenterPinListRoute(): PageRouteConfig {
  return {
    element: <PinList />,
    layout: {
      title: 'خرید جایگاه',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: '/services/promotion-center'
    }
  };
}
